import * as Logger from 'WaLogger'
import * as NextPrev from 'nextprev'
import * as Scroller from "scroller"

require('./responsive-tabs/jquery.responsiveTabs.js');
const Mapv2 = require("MapV2")

const $ = require('jquery');

// const jqueryui_tab = require('jqueryui-tab'); // eslint-disable-line no-unused-vars
// const jqueryui_dialog = require('jqueryui-dialog'); // eslint-disable-line no-unused-vars
const lightbox = require('./jquery-lightbox-0.5/jquery.lightbox-0.5.js'); // eslint-disable-line no-unused-vars

$(window).bind('load', () => {
	Logger.log('load function called');
});
document.addEventListener("DOMContentLoaded", (event) => {
	Logger.log('ready function called');
	NextPrev.enable()
	Scroller.enable()
	/**
	* see if we have a tab page
	*/
	if ($('#tabs').length > 0) {
		// $('#tabs').tabs({active:1, collapsible: false, hide: { effect: 'explode', duration: 1000 }, show: { effect: 'blind', duration: 800 }})
		$('#tabs').responsiveTabs({
			startCollapsed: 'accordion',
			activate : (a, b) => {
				Logger.log([a, b]);
			},
		});
	}
	/**
	* test for lightbox images
	*/
	if ($('a[rel*=lightbox]').length > 0) {
		$('a[rel*=lightbox]').lightBox();
	}
	/**
	* is it a map page the initialize function will test
	*/
	// MapBehavior.initialize();
    const map = Mapv2.map_init()
    if((map !== null) && (map !== undefined))
        map.show()
});
